import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { StrechSchedule }   from "Utils/API";

// Types
import {
    STRECH_SCHEDULE, STRECH_SCHEDULE_LOADING,
    STRECH_SCHEDULE_LIST, STRECH_SCHEDULE_ELEM,
} from "Utils/Types";



/**
 * Fetches the Schedule List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch: Function) => Void}
 */
export function fetchSchedules(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : STRECH_SCHEDULE_LOADING });
        Params.unset(params);
        let data = null;

        switch (type) {
        case "STRECH":
            params.strechID = elemID;
            data = await StrechSchedule.getAllForStrech(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : STRECH_SCHEDULE_LIST, data });
        dispatch(setSection(STRECH_SCHEDULE));
    };
}

/**
 * Fetches a single Schedule
 * @param {Number} scheduleID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchSchedule(scheduleID) {
    return async (dispatch) => {
        const data = await StrechSchedule.getOne({ scheduleID });
        dispatch({ type : STRECH_SCHEDULE_ELEM, data });
    };
}



/**
 * Edits/Creates a Schedule
 * @param {Object} data
 * @returns {(dispatch: Function) => Void}
 */
export function editSchedule(data) {
    return () => StrechSchedule.edit(data);
}

/**
 * Deletes a Schedule
 * @param {Number} scheduleID
 * @returns {(dispatch: Function) => Void}
 */
export function deleteSchedule(scheduleID) {
    return () => StrechSchedule.delete({ scheduleID });
}
